import { render } from "./DialogAgendaRevoke.vue?vue&type=template&id=18c4e936"
import script from "./DialogAgendaRevoke.vue?vue&type=script&lang=js"
export * from "./DialogAgendaRevoke.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__